module.exports = __webpack_public_path__ + "img/icon_menu_disciplina.b48cb155.svg";